import { Actions, ofType } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { filter, switchMap, take } from 'rxjs';

import { MwSharedDirectivesModule } from './@directives/directives.module';
import { MwSharedPipesModule } from './@pipes';
import { MwUserService, userActions } from '@core/auth';
import { MwDirectivesModule } from '@core/directives/directives.module';
import { UserProfileCheckService, UserProfileApiService } from './@pages/user-profile';
import { Config } from '@core/config';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MwDirectivesModule,
    MwSharedDirectivesModule,
    MwSharedPipesModule,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    MwDirectivesModule,
    MwSharedDirectivesModule,
  ],
  declarations: [],
  providers: [UserProfileCheckService, UserProfileApiService],
})
export class CommonAppModule {
  static forRoot(config?: Config): ModuleWithProviders<CommonAppModule> {
    return {
      ngModule: CommonAppModule,
    };
  }

  constructor(
    private readonly userService: MwUserService,
    private readonly userProfileCheckService: UserProfileCheckService,
    private readonly actions$: Actions
  ) {
    this.checkDevincoAccountExistence();
  }

  private checkDevincoAccountExistence(): void {
    const localStorageKey = 'mw-check-devinco-account-existence';
    var hasChecked = localStorage.getItem(localStorageKey) === 'true';

    if (!hasChecked && window.location.href.includes('/?code=')) {
      localStorage.setItem(localStorageKey, 'true');
      this.userService.userProfile$
        .pipe(
          filter((profile) => profile?.userId > 0),
          take(1),
          switchMap(() =>
            this.userProfileCheckService.checkDevincoAccountExistence()
          )
        )
        .subscribe();
    }

    this.actions$.pipe(ofType(userActions.logOut)).subscribe(() => {
      localStorage.removeItem(localStorageKey);
    });
  }
}
